import styled from 'styled-components';

import colours from 'theme/atoms/colours';
import {
  Card as PriorityCardCard,
  Header as PriorityCardHeader,
  PreviousUpdateText,
} from 'priorities/styles/PriorityCard.style';

export const Container = styled('div')<{ $isActive?: boolean }>`
  background-color: ${({ $isActive }) =>
    $isActive ? colours.neutral[400] : colours.neutral[300]};
  border-radius: 35px;
  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.05),
    0 20px 80px -15px rgba(0, 29, 37, 0.1);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow: hidden;
  padding: 10px;
  width: 100%;

  &:focus-visible {
    outline: 2px solid ${colours.neutral[400]};
    outline-offset: 2px;
  }
`;

export const Header = styled('div')`
  align-items: center;
  box-sizing: border-box;
  color: ${colours.neutral[900]};
  display: flex;
  gap: 10px;
  justify-content: space-between;
  padding: 10px;
  width: 100%;
`;

export const HeaderChevron = styled('span')`
  align-items: center;
  color: ${colours.neutral[900]};
  display: inline-flex;
  flex-shrink: 0;
  height: 20px;
  justify-content: center;
  width: 20px;

  svg {
    height: 20px;
    width: 20px;
  }
`;

export const CarouselRow = styled('div')`
  display: flex;
  gap: 5px;
  overflow-x: auto;
  padding: 5px 10px 50px 0;
  margin: -5px -10px -50px 0;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  > * {
    scroll-snap-align: start;
    flex: 0 0 auto;
    min-width: 332px;
    width: 332px;
  }

  > *:only-child {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
  }

  ${PriorityCardCard} {
    background-color: ${colours.neutral[100]};
    border-radius: 30px;
    box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.03);
    gap: 10px;
    padding: 10px;
  }

  ${PriorityCardHeader} {
    gap: 5px;
    padding: 5px 0;
  }

  ${PreviousUpdateText} {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
  }
`;

export const SummaryGrid = styled('div')`
  display: flex;
  gap: 10px;
  width: 100%;
`;

export const SummaryCard = styled('div')`
  background-color: ${colours.shade[0]};
  border-radius: 25px;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  padding: 15px;
`;

export const SummaryList = styled('ul')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const SummaryListItem = styled('li')`
  align-items: flex-start;
  color: ${colours.neutral[600]};
  display: flex;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  gap: 6px;
  line-height: 18px;
  min-width: 0;

  &::before {
    content: '\\2022';
    color: ${colours.neutral[600]};
    flex-shrink: 0;
    line-height: 18px;
  }
`;

export const SummaryListItemText = styled('span')`
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
